/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import Helmet from 'react-helmet';
import { Container } from 'seduo-ui';
import Footer from './Footer';
import Header from './Header';
class Layout extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { children } = this.props;
        return (<div>
                <Helmet titleTemplate="%s" title="Seduo UI components" defaultTitle="Seduo UI components" meta={[
                {
                    name: 'description',
                    content: 'Seduo UI - easy to use React Bootstrap 4 components compatible with React 0.14.x and 15 via Reactstrap',
                },
                {
                    property: 'og:type',
                    content: 'article',
                },
            ]}/>
                <Header />
                <div className="content">
                    <Container>{children}</Container>
                </div>
                <Footer />
            </div>);
    }
}
export default Layout;
